export const USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY =
	'lamnic-user-clicked-on-meeting-notes' as const;
